/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Consents_WithdrawInputs */

const cs_clients_consents_withdraw = /** @type {(inputs: Clients_Consents_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odvolat`)
};

const en_clients_consents_withdraw = /** @type {(inputs: Clients_Consents_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw`)
};

/**
* | output |
* | --- |
* | "Withdraw" |
*
* @param {Clients_Consents_WithdrawInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_consents_withdraw = /** @type {((inputs?: Clients_Consents_WithdrawInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Consents_WithdrawInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_consents_withdraw(inputs)
	return cs_clients_consents_withdraw(inputs)
});